// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_5n-6";
export var headerCell = "_5n-2";
export var rowWrapper = "_5n-4";
export var stickyAggregationCell = "_5n-a";
export var stickyAggregationRow = "_5n-7";
export var stickyColumnCell = "_5n-9";
export var stickyColumnHeaderCell = "_5n-8";
export var table = "_5n-1";
export var virtualRowWrapper = "_5n-5";
export var virtualTableContainer = "_5n-0";
export var white = "_5n-3";